'use client';

export function ConnectingView() {
  return (
    <div className="flex min-h-screen items-center justify-center pt-20 pb-24">
      <div className="flex flex-col items-center gap-4">
        <div className="w-2 h-2 rounded-full bg-primary-bright animate-ping" />
        <p className="font-mono text-xs tracking-widest text-primary">CONNECTING...</p>
      </div>
    </div>
  );
}
